"use client";

import React from "react";
import { Star, ExternalLink } from "lucide-react";
export default function CustomerReviews() {
  return <section id="reviews" className="bg-gradient-to-b from-white to-[#F7F9FC] border-t border-[#E3E7EF] py-8 lg:py-14">
      <div className="max-w-[1180px] mx-auto px-3 lg:px-8">

        <div className="text-center mb-5 lg:mb-9">
          <h2 className="text-[28px] lg:text-[50px] font-black italic uppercase leading-none">
            Customer <span className="text-[#0B4DBA]">Reviews</span>
          </h2>
          <p className="mt-2 lg:mt-3 text-[#5B6575] text-[12px] lg:text-[16px]">
            See what customers say about Nova Tire Center on Google and Yelp.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-6">

          {/* GOOGLE */}
          <div className="bg-white rounded-[14px] lg:rounded-[18px] border border-[#E3E7EF] shadow-[0_8px_18px_rgba(7,27,58,0.07)] lg:shadow-[0_12px_28px_rgba(7,27,58,0.08)] p-3 lg:p-6">
            <div className="flex items-center justify-between mb-3 lg:mb-5">
              <div>
                <p className="text-[10px] lg:text-[13px] font-black uppercase text-[#5B6575]">
                  Google Rating
                </p>
                <h3 className="text-[26px] lg:text-[34px] font-black text-black leading-none">
                  4.9
                </h3>
              </div>
              <div className="text-[22px] lg:text-[28px] font-black text-[#0B4DBA]">
                G
              </div>
            </div>

            <div className="flex gap-0.5 lg:gap-1 mb-3 lg:mb-5">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 lg:w-5 lg:h-5 fill-[#FFB000] text-[#FFB000]" />)}
            </div>

            <p className="text-[#5B6575] text-[10px] lg:text-sm leading-snug lg:leading-relaxed mb-3 lg:mb-5">
              Customers choose us for fast tire repair, honest service, and same-day help in Los Angeles.
            </p>

            <a href="https://www.google.com/maps/place/Nova+Tire+Center/@34.0542974,-118.3797393,17z/data=!4m8!3m7!1s0x80c2b9434ecdbaa1:0x8ff20ca23b3c94c4!8m2!3d34.0542974!4d-118.3797393!9m1!1b1!16s%2Fg%2F11vwy3ylgz?authuser=0&hl=en&entry=ttu&g_ep=EgoyMDI2MDkwOS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 lg:gap-2 text-[#0B4DBA] font-black uppercase text-[10px] lg:text-sm">
              Google Reviews <ExternalLink className="w-3 h-3 lg:w-4 lg:h-4" />
            </a>
          </div>

          {/* YELP */}
          <div className="bg-white rounded-[14px] lg:rounded-[18px] border border-[#E3E7EF] shadow-[0_8px_18px_rgba(7,27,58,0.07)] lg:shadow-[0_12px_28px_rgba(7,27,58,0.08)] p-3 lg:p-6">
            <div className="flex items-center justify-between mb-3 lg:mb-5">
              <div>
                <p className="text-[10px] lg:text-[13px] font-black uppercase text-[#5B6575]">
                  Yelp Rating
                </p>
                <h3 className="text-[26px] lg:text-[34px] font-black text-black leading-none">
                  4.8
                </h3>
              </div>
              <div className="text-[22px] lg:text-[28px] font-black text-[#FF5A00]">
                Y
              </div>
            </div>

            <div className="flex gap-0.5 lg:gap-1 mb-3 lg:mb-5">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 lg:w-5 lg:h-5 fill-[#FFB000] text-[#FFB000]" />)}
            </div>

            <p className="text-[#5B6575] text-[10px] lg:text-sm leading-snug lg:leading-relaxed mb-3 lg:mb-5">
              Local drivers trust Nova Tire Center for tire replacement, flat repair, TPMS, brakes, and oil service.
            </p>

            <a href="https://www.yelp.com/search?find_desc=Nova+Tire+Center&find_loc=8635+W+Pico+Blvd+Los+Angeles" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 lg:gap-2 text-[#0B4DBA] font-black uppercase text-[10px] lg:text-sm">
              Yelp Reviews <ExternalLink className="w-3 h-3 lg:w-4 lg:h-4" />
            </a>
          </div>

          {/* TRUST */}
          <div className="col-span-2 lg:col-span-1 bg-[#071B3A] rounded-[18px] border border-[#071B3A] shadow-[0_12px_28px_rgba(7,27,58,0.14)] p-6 text-white">
            <p className="text-[13px] font-black uppercase text-[#7DB2FF] mb-3">
              Trusted Local Shop
            </p>

            <h3 className="text-[28px] font-black italic uppercase leading-tight mb-4">
              Fast Service.
              <br />
              Honest Work.
            </h3>

            <p className="text-white/70 text-sm leading-relaxed mb-5">
              Same-day tire service, no appointment needed, and easy access from Pico Blvd.
            </p>

            <p className="text-[#FFB37A] text-sm font-black uppercase">
              Top local tire service in Los Angeles
            </p>
          </div>

        </div>
      </div>
    </section>;
}